import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
    expanded: {},

    button: {},
    iconExpand: {
      color: COLORS.neutral.white,
      fontSize: theme.typography.pxToRem(16),
    },
    collapse: {},
    items: {
      position: 'relative',
      display: 'flex',
      flexFlow: 'column nowrap',
      padding: theme.spacing(0.75, 0),

      '&:after': {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 27,
        borderLeft: `1px solid ${COLORS.neutral.white}`,
        content: '""',

        mixBlendMode: 'lighten',
        opacity: 0.4,
      },
    },
    item: {
      '& + &': {
        marginTop: theme.spacing(0.75),
      },
    },
  }),
  { name: 'SidebarSubmenu' }
);
